import SuccessIcon from 'images/app/success.svg';
import FailIcon from 'images/app/fail.svg';
import OnIcon from 'images/app/on.svg';
import CheckShelfIcon from 'images/app/shelf-check.svg';
import DoingShelfIcon from 'images/app/shelf-doing.svg';
import DoneShelfIcon from 'images/app/shelf-done.svg';
import TotoShelfIcon from 'images/app/shelf-todo.svg';
import UnderLineShelfIcon from 'images/app/shelf-underline.svg';

export const TAB_AGENCY_CHECKED_IN = '已入驻';
export const TAB_AGENCY_REVIEW_ON = '审核中';
export const OPERATION_AUTH_CODE = '1029'; // 数据中台操作权限码
export const VIEW_AUTH_CODE = '8102'; // 数据中台查看权限码
export const APP_ID_APPLY_URL = 'https://developers.e.qq.com/'; // 申请appId地址
// 数字类型检验
export const NUMBERS_VALIDATOR = {
  pattern: /^[\d\s,]{1,10}$/i,
  message: '请输入10位以下数字类型',
};

// 一级分类
export const Category = {
  adEfficiency: 0,
  privateDomain: 1,
  rta: 2,
  contentService: 11,
  dataService: 12,
  daiyunying: 13,
  other: 90,
  none: 100,
};

export const CATEGORY_LIST = [
  // 广告营销工具
  { value: Category.adEfficiency, label: '投放提效工具' },
  { value: Category.privateDomain, label: '私域运营工具' },
  { value: Category.rta, label: 'RTA投放工具' },
  // 广告营销服务
  { value: Category.contentService, label: '内容服务' },
  { value: Category.dataService, label: '数据服务' },
  { value: Category.daiyunying, label: '代运营服务' },
  // 隐藏类
  { value: Category.other, label: '其他' },
];
// 审核状态对应的下标
export const AUDIT_STATUS_COLOR = [
  // {
  //   label: '待审核',
  //   icon: OnIcon,
  // },
  {
    label: '审核中',
    icon: OnIcon,
  },
  {
    label: '审核未通过',
    color: '#E63D2E',
    icon: FailIcon,
  },
  {
    label: '审核通过',
    icon: SuccessIcon,
  },
];

// 应用状态对应的下标
export const APPLICATION_STATUS_COLOR = [
  {
    label: '待上架',
    icon: TotoShelfIcon,
  },
  {
    label: '上架中',
    icon: DoingShelfIcon,
  },
  {
    label: '验收中',
    icon: CheckShelfIcon,
  },
  {
    label: '已上架',
    icon: DoneShelfIcon,
  },
  {
    label: '已下架',
    icon: UnderLineShelfIcon,
    color: '#939599',
  },
];

//  需要转成file格式的名称
export const TRANS_UPLOAD_NAME_LIST: string[] = [];

export const USE_PTP_FE_COMMON = false; // 是否使用ptp-fe-common里的组件

export const NOT_UPDATE_APP_TIPS = '当前审核未通过, 不可操作';
